import React from 'react';
import { Col, Row } from 'reactstrap';
// eslint-disable-next-line import/no-named-as-default
import CommonToggleSwitch from '../../common/components/CommonToggleSwitch';

function NotificationsItem({ title, description, type, config, onChange }) {
  const isNotificationEnabled = (isPushNotification = true) => {
    const key = isPushNotification ? 'pushNotifications' : 'emailNotifications';
    return config?.[key]?.find((it) => it.notificationType === type)?.enabled ?? false;
  };

  return (
    <Row className="mt-2 settings__notification-item-content">
      <Col>
        <Row className="align-items-center flex-nowrap">
          <Col className="settings__notification-item-title">{title}</Col>
          <Col xs="auto" className="settings__notification-item-checkbox">
            <CommonToggleSwitch
              onChange={({ target }) => onChange(target.checked, type, true)}
              checked={isNotificationEnabled(true)}
            />
          </Col>
          <Col xs="auto" className="settings__notification-item-checkbox ms-2">
            <CommonToggleSwitch
              onChange={({ target }) => onChange(target.checked, type, false)}
              checked={isNotificationEnabled(false)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={4} sm={6} md={8} className="settings__notification-item-description">
            {description}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default NotificationsItem;
